import { SmartChargeSettingsFormModel } from 'src/Libs/smart-charge/models'
import { SmartChargeSettingsUpdateDto } from 'src/Libs/smart-charge/dto'

const settingsFormToDtoTransformer = (formValues: SmartChargeSettingsFormModel): SmartChargeSettingsUpdateDto => {
  const doApplyForecastSettings = formValues.emsWeatherRegulatedChargeEnabled
  const weatherForecastActive = formValues.weatherForecastActive.map(item => ({ active: item.isActive, pmId: item.pmId }))

  return {
    emsWeatherRegulatedChargeEnabled: formValues.emsWeatherRegulatedChargeEnabled,
    weatherCalcMode: doApplyForecastSettings ? formValues.weatherCalcMode : undefined,
    weatherForecastActive: doApplyForecastSettings ? weatherForecastActive : undefined,
    emsStartManualCharge: formValues.emsStartManualCharge,
  } as SmartChargeSettingsUpdateDto
}
export default settingsFormToDtoTransformer
